export function getPreviewTransferUrl({ transferId, secret, items }) {
  const params = {
    transferId,
    secret,
  };

  return items.length === 1
    ? getPreviewUrl({ fileId: items[0].id, ...params })
    : getGridUrl(params);
}

export function getPreviewUrl({ transferId, recipientId, secret, fileId }) {
  return ['/downloads', transferId, recipientId, secret, 'preview', fileId]
    .filter(Boolean)
    .join('/');
}

export function getTransferDownloadUrl({ transferId, recipientId, secret }) {
  return ['/downloads', transferId, recipientId, secret]
    .filter(Boolean)
    .join('/');
}

export function getGridUrl({ transferId, recipientId, secret }) {
  const downloadUrl = getTransferDownloadUrl({
    transferId,
    recipientId,
    secret,
  });

  return `${downloadUrl}/grid`;
}

export default {
  getPreviewTransferUrl,
  getGridUrl,
  getTransferDownloadUrl,
  getPreviewUrl,
};
